import React from "react";
import Header from "../components/common/header";
import MenuComponent from "../components/common/menu";
import { useLocation } from "react-router-dom";

const PrivateRoute = ({ component: Component }) => {
  const location = useLocation();
  const hideLayout = location.pathname.includes("/login-on-behalf");

  if (hideLayout) {
    // ✅ Clean page (no sidebar, no header, no dashboard)
    return <React.Fragment>{Component}</React.Fragment>;
  }

  return (
    <React.Fragment>
      <div className="container">
        <div className="dashboard">
          <MenuComponent />
          <div className="dashboard-right">
            <Header />
            {Component}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PrivateRoute;
